<template>
	<div id="appbox">
		<div class="top_heard">
			<div class="top_box" v-if="screenWidth>785" >
				<div class="logo_box"  @click="gohome()">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
				<div class="top_gatebox">
					<div class="manage_switch" v-if="screenWidth>785">
						<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
						  <el-option
						    v-for="item in manageoptions"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							>
						  </el-option>
						</el-select>
					</div>
					
				</div>
				<div class="top_search_box" v-if="screenWidth>785" >
					<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
						    v-for="item in options"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							
							>
						  </el-option>
						</el-select>
						<!-- <i class="el-icon-search"></i> -->
						<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
					</div>
					  
				</div>
				<div class="top_right">
					<div class="top_Mobiletype" @click="goregister()">
						账号注册/绑定
					</div>
					<div class=""  v-if="token" >
						欢迎访问!
					</div>
					<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
						登出
					</div>
				</div>
			</div>
			<div class="top_tab_box">
				<van-nav-bar title="" style="color: #ffffff ;font-weight: 600;" @click-right="vannavshow=true" v-if="screenWidth<785" >
					<template #left>
						<div class="vannav_title" style="color: #217495;font-size: 16px;" >
							专家信息
						</div>
					</template>
					<template #title>
						<div class="vannav_title" style="width: 180px;padding: 20px;">
								<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
						</div>
					</template>
				  <template #right>
					  <van-icon name="ellipsis"  size="20"    />
				  </template>
				</van-nav-bar>
				<van-popup v-model="vannavshow"  :style="{ height: '50%' }" position="top">
					<van-picker
					  title=""
					  show-toolbar
					  :columns="vannavlist"
					  confirm-button-text="进入"
					  @confirm="vanlinkgo"
					  @cancel="vannavmenushow"
					  @change="onChange"
					/>
				</van-popup>
				<div class="toptabnav" v-if="screenWidth>785" >
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  mode="horizontal"
						  @select="handleSelect"
						  router
						  background-color="#1b9d57"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
							<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
				<div class="top_banner">
					<el-carousel ref="carousel" :interval="4000"  :height="screenWidth>785?'480px':(screenWidth*551/1920)+'px'" >
					  <el-carousel-item v-for="item in platelist" :key="item">
					    <h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"  style="width: 100%;height: 100%;" alt="" srcset=""></h3>
					  </el-carousel-item>
					</el-carousel>
				</div>
<!-- 				<div class="top_plate">
					<div class="plate_item" v-for="(plate, index) in platelist" :key="plate" @mouseover="showstep(index)" @click="goplate(plate.id)" >
						<div class="plate_icon">
							<img :src="plate.icon" alt="" srcset="">
						</div>
						<div class="plate_title">
							{{plate.title}}
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="Home_column2" :style="screenWidth>785?'':'width:100%;'">
			<div class="expert_box" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-direction: column;'">
				<div class="expert_img">
					<img :src="expertdata.icon" alt="" srcset="">
				</div>
				<div class="expert_msgbox" :style="screenWidth>785?'':'    margin-left: 0px;'">
					<div class="expert_title">
						{{expertdata.title}}
					</div>
					<div class="expert_msg">
						{{expertdata.content}}
					</div>
				</div>
			</div>
<!-- 			<div class="guidebox">
				<div class="guide_msgbox">
					<div class="guide_title">
						研学旅行指导师加盟
					</div>
					<div class="guide_subtitle">
						权威专家指导师培训，定制式实操课程
					</div>
					<div class="guide_msg">
						权威培训专家团队: 教育部、省教育厅、教育院校等教育系统专家讲师团队:定制式实操课程: 专业化定制课程，研学活动实践与权威专家面对面交流，权威机构认证证书。
					</div>
					<div class="guide_buttons">
						<el-button type="primary" @click="goregister()" >加入研学指导师人才库</el-button>
					</div>
				</div>
				<div class="guide_img">
					<img src="../../../static/img/jidi.jpg" alt="" srcset="">
				</div>
			</div> -->
		</div>
		<div :class="tops?'navbar':'navbar-top'" v-if="screenWidth>785" >
		     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
		             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
								<div style="font-size: 14px;">首页</div></a>
		     </el-tooltip>
		     <div  class="qrShow3 right2"   v-if="showofficialQR">
					<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
							
				    <div style="font-size: 14px;">公众号</div></a>
				<div  class="qrShow2 right2" v-if="showserviceQR">
					<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
				</div>
				<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
							
				    <div style="font-size: 14px;">客服</div></a>
		     <div  class="qrShow right" v-if="showQR">
							<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
		     </div>
		       <!-- <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
		         <div style="font-size: 14px;">手机端</div></a> -->
		     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
		         <a @click="gotop"><i class="el-icon-caret-top"></i>
		         <br>
		         <span>顶部</span></a>
		     </el-tooltip>
		 </div>
		<!-- footer -->
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
</template>

<script>
	import {  getNewslist, getCategory, getCamplist, getPc, getMapcamp, getRegion ,getTraveler, getPlate,getTeacher,getexpert,getbottomnav} from '@/request/api'
	
	export default {
	  name: "Camplist",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
			  bottomnav:[],
			  //搜索相关
				top_search_url:'/Siteall',
				options: [
				{
					value: '/Siteall',
					label: '全站搜索'
				},{
				  value: '/Camplist',
				  label: '营地搜索'
				}, {
				  value: '/Baselist',
				  label: '基地搜索'
				}, {
				  value: '/Courselist',
				  label: '课程搜索'
				},{
				  value: '/Newslist',
				  label: '资讯搜索'
				},
				{
				  value: '/Activitylist',
				  label: '活动搜索'
				},
				{
				  value: '/Linelist',
				  label: '线路搜索'
				},
				{
				  value: '/traveler',
				  label: '机构搜索'
				},{
				  value: '/mentorlist',
				  label: '指导师搜索'
				},],
				//搜索相关
			  manage_url:'',
			  manageoptions:[
			  	{
			  	  value: 'http://qianjin.wanjiaxiao.cn/',
			  	  label: '研学报备'
			  	}, {
			  	  value: 'https://admin.henanyanxue.com/',
			  	  label: '管理入口'
			  	},
			  	
			  ],
			  stitle:'',
				platelist:[],
				activeIndex2: '/expertlist',
				phoneboxshow:false,
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				logintype:true,
				expertdata:{},
				banner:[
				],
				camptypes:[
					{ text: '全部', value: 0 },
					{ text: '基地', value: 2 },
					{ text: '营地', value: 1 },
				],
				camptype:1,
				camplist:[],
				quicklist:[],
				maplist:[],
				aclist:[],
				newsiconon:'',
				category_id:'',
				total:0,
				page_index:1,
				uuid:'',
				newsdata:{},
				pcsetdata:{},
				openmap:{},
				show: false,
				showinfowindow:false,
				regionlist:[],
				region_type:'',
				modules:'',
				showQR:false,
			 showserviceQR:false,
			  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
				//屏幕宽高
								// 屏幕宽度
								screenWidth: window.innerWidth,
								top_bannerWidth:Math.round(window.innerWidth/3.42),
								// 屏幕高度
								screenHeight: window.innerHeight,
								//手机端导航栏
								vannavshow:false,
								vannavlist:[
									{
										link:'/Home',
										text:'研学首页'
									},
									{
										link:'/Camplist',
										text:'营地列表'
									},
									{
										link:'/Newslist',
										text:'资讯资讯'
									},
									{
										link:'/Baselist',
										text:'基地列表'
									},
									{
										link:'/Courselist',
										text:'研学课程'
									},
									{
										link:'/Activitylist',
										text:'研学活动'
									},
									{
										link:'/Linelist',
										text:'研学线路'
									},
									{
										link:'/traveler',
										text:'研学机构'
									},
									{
										link:'/mentorlist',
										text:'研学指导师'
									},
									{
										link:'/expertlist',
										text:'专家团队'
									},
                  {
                    link: '/OrgRegister',
                    text: '入驻平台'
                  },
								],
		      }
	  },
	  beforeCreate(){
	  	   const loading = this.$loading({
	  	            lock: true,
	  	            text: '页面载入……',
	  	            // spinner: 'el-icon-loading',
	  	            background: '#ffffff'
	  	          });
	  },
	  created() {
		  this.getpcset()  
	  },
	  mounted() {
		 const { id } = this.$route.query;
		 this.uuid = id
		 window.addEventListener('resize', this.handleResize, true)
		 var token = localStorage.getItem('token')||''
		 this.token=token
		  this.getPlate()
		   this.getbottomnav()
		   // const { id } = this.$route.query;
		   // this.uuid = id
			this.getexpert()
			// this.getMapcamp()
			this.getRegion()
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  // 销毁监听
	  		beforeDestroy() {
	  		  window.removeEventListener('resize', this.handleResize);
	  		},
	  methods: {
		  gotopsearch(){
		  		  this.$router.push({
		  		    path: this.top_search_url,
		  		    name: this.top_search_url,
		  		    query: {
		  		      stitle: this.stitle,
		  		    }
		  		  }); 
		  },
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		//this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
	  		  vanlinkgo(e){
	  		  		  console.log(e)
	  		  		  this.$router.push({
	  		  		    path: e.link,
	  		  		    name: e.link,
	  		  		    query: {
	  		  		    }
	  		  		  }); 
	  		  },
	  		  vannavmenushow(){
	  		  		this.vannavshow=false  
	  		  },
	  		  handleResize() {
	  		  		   this.top_bannerWidth = 0;
	  		    this.screenWidth = window.innerWidth;
	  		  		this.top_bannerWidth=window.innerWidth/3.42
	  		  		console.log('screenWidth',this.screenWidth,this.top_bannerWidth)
	  		    this.screenHeight = window.innerHeight;
	  		  },
		  getbottomnav(){
		  		  var data={
		  			  page_index:1,
		  			  page_size:15
		  		  }
		  		getbottomnav(data).then(res=>{
		  			this.bottomnav=res.data.data.list
		  		})  
		  },
		  gobottomnav(type,link){
		  		  if(type==1){
		  			  this.$router.push({
		  			  	path:link
		  			  });
		  		  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  logout(){
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  showstep(ind) {
		       this.$refs.carousel.setActiveItem(ind)
		     },
		  goplate(id){
			  this.modules=id
			  this.page_index=1
			  this.getlist()
		  },
		  getexpert(){
			  var data={
			  	uuid:this.uuid
			  }  
			  getexpert(data).then(res=>{
					console.log(res.data)
					this.expertdata=res.data.data
					const loading = this.$loading({
			  			           lock: true,
			  			           text: 'Loading',
			  			           spinner: 'el-icon-loading',
			  			           background: 'rgba(0, 0, 0, 0.7)'
			  			         });
					loading.close();
			  			  // this.quicklist=res.data.data.list
			    }).catch(error => {
			  	  console.error(error);
			  });
		  },
		  getPlate(){
		  		var data={
		  			
		  		}  
		  		getPlate(data).then(res=>{
		  			this.platelist=res.data.data
		  		})
		  },
		  showphonebox(){
		  		this.phoneboxshow=true  
		  },
		  closephonebox(){
		  		this.phoneboxshow=false  
		  },
		  goregister(e){
		  			  this.$router.push({
		  			    path: "/register",
		  			    name: "/register",
		  			  		  query: {
		  			  		  }
		  			  });
		  },
		  gohome(e) {
		    this.$router.push({
		      path: "/Home",
		      name: "/Home",
		  			  query: {
		  			  }
		    });
		  },
		  getRegion(){
			var data={}
			getRegion(data).then(res=>{
				this.regionlist=res.data.data
			})
		  },
			getMapcamp(){
				var data={
					type:this.camptype,
				}
				getMapcamp(data).then(res=>{
					console.log(res)
					
					this.maplist=res.data.data
					this.openmap=res.data.data[0]
					const loading = this.$loading({
							 lock: true,
							text: '页面载入……',
							// spinner: 'el-icon-loading',
							background: '#ffffff'
						   });
					loading.close();
				})
			},
			infoWindowClose (index) {
		        this.showinfowindow = false
			},
			infoWindowOpen (index) {
				this.openmap=this.maplist[index]
				this.showinfowindow = true
				console.log(this.maplist[index])
			},
			
			getpcset(){
				getPc().then(res=>{
					this.pcsetdata=res.data.data
					const loading = this.$loading({
							 lock: true,
							 text: 'Loading',
							 spinner: 'el-icon-loading',
							 background: 'rgba(0, 0, 0, 0.7)'
						   });
					loading.close();
				})  
			},
		  camptypetab(val){
			  this.region_type=val
			  this.page_index=1
			  this.getlist()
		  },
		  pagechange(val){
		  			  this.page_index=val
		  			   this.getlist()
		  },
		  getlist(){
			var data={
				search:this.stitle,
				page_index: this.page_index,
				modules:this.modules,
				page_size: 12,
			}  
			getexpert(data).then(res=>{
				console.log(res.data)
				this.camplist=res.data.data.list
				this.total=res.data.data.total
			}).catch(error => {
				console.error(error);
			});
		  },
		  handleClick(e){
				console.log(e,this.category_id)
				 this._getNewslist()
		  },
		  onitemopen(index){
			  this.newsiconon=index
		  },
		  gettypes(){
			  var data={}
			  getCategory(data).then(res=>{
			    			  console.log(res.data)
			    			  this.types=res.data.data
							  this.category_id=res.data.data[0].id
							  this._getNewslist()
			    }).catch(error => {
			    			  console.error(error);
			    			});
		  },
		  /*
		   * 查看详情
		   * */
		  detail(e) {
		    this.$router.push({
		      path: "/travelerdetails",
		      name: "travelerdetails",
		      query: {
		        id: e
		      }
		    });
		  },
	  }
	};
</script>

<style scoped>
	body{
		background: #ffffff;
	}
	#appbox{
		background: #ffffff;
	}
	.Home_column2{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.expert_box{
		width:calc(100% - 40px);
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding: 20px;
		
	}
	.expert_img{
		width: 300px;
	
	}
	.expert_img img{
		width: 100%;
		object-fit: contain;
	}
	.expert_msgbox{
		flex: 1;
		margin-left: 20px;
		
	}
	.expert_title{
		padding: 20px;
		font-size: 20px;
		color:#1b9d57 !important;
		    font-weight: 600;
		    text-align: center;
	}
	.expert_msg{
		text-indent:2rem;
		font-size: 16px;
		color: #606266;
		    text-align: left;
	}
	.guidebox{
		padding: 30px 0px;
		border-top: 1px solid #EBEEF5;
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items:center;
	}
	.guide_img{
		width: 480px;
		
	}
	.guide_img img{
		display: block;
		width: 100%;
		border-radius: 8px;
		object-fit: contain;
	}
	
	.guide_msgbox{
		width: calc(100% - 500px);
		
	}
	.guide_title{
		font-size: 28px;
		    color: #333;
		    line-height: 40px;
			    text-align: left;
	}
	.guide_subtitle{
		font-size: 18px;
		    color: #666;
		    line-height: 28px;
		    margin-top: 5px;
			    text-align: left;
	}
	.guide_msg{
		    margin: 30px 0px 50px;
		width: 490px;
		    font-size: 14px;
		    color: #666;
		    line-height: 30px;
			    text-align: left;
	}
	.guide_buttons{
		display: flex;
		justify-content: flex-start;
		
	}
	.column2_box{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: flex-end;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
		margin-bottom: 30px;
	}
	.expert_subtitle{
		text-indent:2rem;
		font-size: 14px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		    /* min-height: 48px; */
		
	}
	.mentor_imgs{
		width:100px !important;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		max-width: 210px;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
</style>